import { useState } from "react";
import RequestHeader from "./RequestHeader";
import { Box } from "@material-ui/core";
import RequestRow from "./RequestRow";
import { usePoolMonitoringContext } from "src/context/monitoring/poolMonitoringContext";
import { useParams } from "react-router-dom";
import MobileDetailRequest from "./MobileDetailRequest";
import usePagination from "src/hooks/usePagination";
import CssPagination from "src/components/Pagination/CssPagination";

export default function RequestList() {
  const [selectedRequest, setSelectedRequest] = useState(null);
  const [isDetail, setIsDetail] = useState(false);
  const { data } = usePoolMonitoringContext();
  const { pool } = useParams();
  const requests = data[pool].requests;

  const { data: paginationData, jump, maxPage, currentPage } = usePagination(requests);

  return isDetail ? (
    <MobileDetailRequest request={selectedRequest} setIsDetail={setIsDetail} />
  ) : (
    <Box>
      <RequestHeader />
      {paginationData?.map((request) => (
        <RequestRow
          request={request}
          key={request._id}
          setSelectedRequest={setSelectedRequest}
          setIsDetail={setIsDetail}
        />
      ))}
      <CssPagination
        mt={1}
        paginationProps={{ page: currentPage, count: maxPage, onChange: (_, page) => jump(page) }}
      />
    </Box>
  );
}
